import React from 'react';
import { connect } from 'react-redux';

import api from 'api';
import { addNotification } from 'apps/core/flash_notifications/actions';
import _UserProfile from './UserProfile';

import Fetcher from 'components/Fetcher';

import { SET_SITE_ROLE } from 'apps/core/site_options/store';

const defaultState = {
    id: null,
    name: '',
    email: '',
    apps: {},
    session_expiry: '',
};

// reducers

const SET_USER = 'SET_USER';
export const SET_EXPIRY = 'SET_EXPIRY';
export const reducer = (state = defaultState, action = {}) => {
    switch (action.type) {
        case SET_USER:
            return { ...state, ...action.user };

        case SET_EXPIRY:
            return { ...state, session_expiry: action.session_expiry };

        default:
            return state;
    }
};

// actions

export function fetchUser(callbacks = {}) {
    return dispatch => {
        callbacks.start && callbacks.start();

        api.get('user/')
            .then(user => {
                dispatch({ type: SET_USER, user });
                dispatch({ type: 'LOGGED_IN' });
                import(`../../../brands/${user.site_brand}/index.js`).then(module => {
                    const brand = module.default;
                    dispatch({ type: SET_SITE_ROLE, role: user.site_role, brand });
                });
                callbacks.done && callbacks.done();
            })
            .catch(error => {
                if (error.status) {
                    dispatch({ type: 'LOGIN_ERROR', error: 'Please login.' });
                }
                callbacks.fail && callbacks.fail(error);
            });
    };
}

export function saveUser(userData, callbacks = {}) {
    return dispatch => {
        callbacks.start();

        api.patch('user/', userData)
            .then(data => {
                dispatch({ type: SET_USER, user: data });
                callbacks.done();
            })
            .catch(error => {
                callbacks.fail(error);
            });
    };
}

export const actions = { fetchUser, saveUser };

// Connected components

export const UserProfile = connect(
    ({ user }, ownProps) => ({ user }),
    (dispatch, ownProps) => ({
        saveUser: (userData, callbacks) => dispatch(saveUser(userData, callbacks)),
        fetchUser: callbacks => dispatch(fetchUser(callbacks)),
        addNotification: msg => dispatch(addNotification(msg)),
    })
)(_UserProfile);

export const FetchUser = connect(
    ({ user }, ownProps) => ({ user }),
    (dispatch, ownProps) => ({
        fetchUser: callbacks => dispatch(fetchUser(callbacks)),
    })
)(function FetchUser({ children, fetchUser, user }) {
    if (user.id) {
        return children;
    }
    return <Fetcher fetch={fetchUser} render={() => children} />;
});
